import SFAQs from "./SFAQs_web"
export default SFAQs
